import React, {useState} from 'react'
import {Dialog, DialogContent, DialogTitle, DialogActions} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { AppContext } from './index'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  card: {
    width: '100%',
    borderBottom: '3px solid black'
  },
  imageContainer: {
    width: '100%',
    height: '100%',
  },
  image: {
    zIndex: 2,
    width: 200,
    height: 200,
    borderRadius: 20,
  },
  delete: {
    '&:hover': {
      cursor:'pointer',
      textDecoration: 'underline'
    }
  },
}));


export function CouponCode(props) {
  const classes = useStyles()
  let {code, setCode} = props
  return (
    <div className={classes.container}>
      <TextField fullWidth color={'inherit'} style={{color: 'black'}} label={'Christmas Code'} value={code} onChange={e => setCode(e.target.value)}/>
    </div>
  )





}

